import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "self-eva"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "content-box"
};
const _hoisted_4 = {
  key: 0,
  class: "article-box"
};
const _hoisted_5 = {
  class: "article"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "paper-content-box"
};
const _hoisted_8 = {
  class: "paper-content-title"
};
const _hoisted_9 = {
  class: "paper-content"
};
const _hoisted_10 = {
  class: "audio-box"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString($setup.paper.description), 1)]), _createElementVNode("div", _hoisted_3, [$props.step != 0 && $props.examInfo.skill == 'S4' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "paper-content-title"
  }, [_createElementVNode("p", null, "我的作文")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("pre", {
    innerHTML: $setup.articleText
  }, null, 8, _hoisted_6)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("p", null, "描述语", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paper.choices, (choicesValue, choicesKey) => {
    return _openBlock(), _createElementBlock("p", {
      key: 'choices' + choicesKey
    }, _toDisplayString(choicesValue), 1);
  }), 128))]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paper.questions, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: 'questions' + questionIndex,
      class: _normalizeClass($setup.setClassName(questionItem))
    }, [_withDirectives(_createElementVNode("p", null, _toDisplayString(questionItem.stem), 513), [[_vShow, !questionItem.explain]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paper.choices, (choicesValue, choicesKey) => {
      return _withDirectives((_openBlock(), _createElementBlock("p", {
        key: 'questionchoices' + choicesKey
      }, [_createVNode(_component_el_radio, {
        modelValue: $setup.answerData.answer[$setup.paper.id + '-' + questionItem.id],
        "onUpdate:modelValue": $event => $setup.answerData.answer[$setup.paper.id + '-' + questionItem.id] = $event,
        label: choicesKey,
        size: "large"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("  ", -1)]))]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue", "label"])])), [[_vShow, !questionItem.play && !questionItem.explain]]);
    }), 128)), _withDirectives(_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      onClick: $event => $setup.pause(questionItem.id)
    }, null, 8, _hoisted_11), [[_vShow, $setup.audioStatus[questionItem.id] == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon",
      onClick: $event => $setup.play(questionItem.id)
    }, null, 8, _hoisted_12), [[_vShow, $setup.audioStatus[questionItem.id] == 'pause']])], 512), [[_vShow, questionItem.play]]), _withDirectives(_createElementVNode("p", {
      class: "explain"
    }, _toDisplayString(questionItem.stem), 513), [[_vShow, questionItem.explain]])], 2);
  }), 128))])])]), _createElementVNode("footer", null, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.taskEnd
  }, {
    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("提交", -1)]))]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("audio", {
    id: "audio",
    onEnded: _cache[0] || (_cache[0] = (...args) => $setup.playEnded && $setup.playEnded(...args)),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $setup.audioUrl,
    type: "audio/mpeg"
  }, null, 8, _hoisted_13)], 32)]);
}